







































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { emptyText, loadingText } from '@/utils/constants';
import * as ITypes from '@/store/brand-audit/apply/types';
import Confirm from '@/components/dialog/Confirm.vue';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';

const Apply = namespace('brandAudit/apply');

@Component({
  components: { Confirm, TooltipIcon },
})
export default class EnterpriseBrandAuthAudit extends Vue {
  @Apply.Action('queryMyAudits') public queryAudits!: ITypes.IActions['queryMyAudits'];
  @Apply.State('auditList') public auditList!: ITypes.IBrandAuthApply;

  @Apply.Action('acceptApplication') public acceptApplication!: ITypes.IActions['acceptApplication'];
  @Apply.Action('rejectApplication') public rejectApplication!: ITypes.IActions['rejectApplication'];
  @Apply.State('processing') public processing!: boolean;

  @Apply.Mutation('setConfirm') public setConfirm!: ITypes.IActions['setConfirm'];
  @Apply.State('confirm') public confirm!: ITypes.IConfirm;

  public emptyText = emptyText;
  public loadingText = loadingText;
  public selectedId: number | null = null;

  public headers = [
    { text: '会员/企业编码', value: 'orgCode' },
    { text: '会员/企业名称', value: 'orgName' },
    { text: '品牌编码', value: 'brandCode' },
    { text: '品牌名称', value: 'brandName' },
    { text: '操作', value: 'action', width: '90px' },
  ];

  public get confirmVisible() {
    const { type, visible } = this.confirm;
    return visible && (type === 'reject-application');
  }

  public set confirmVisible(visible: boolean) {
    if (!visible) {
      this.selectedId = null;
      this.setConfirm({ visible: false });
    }
  }

  public created() {
    this.queryAudits();
  }

  // 是否正在'处理中'
  public isProcess(record: ITypes.IBrandAuthApplyDto) {
    return this.processing && (record.id === this.selectedId);
  }

  // 同意申请
  public async onAccept(record: ITypes.IBrandAuthApplyDto) {
    this.selectedId = record.id;
    await this.acceptApplication({ id: this.selectedId, operate: true });
    this.queryAudits();
    this.selectedId = null;
  }

  // 拒绝申请
  public onReject(record: ITypes.IBrandAuthApplyDto) {
    this.selectedId = record.id;
    const content = '是否确认拒绝申请？';
    this.setConfirm({ visible: true, type: 'reject-application', title: '拒绝申请', content });
  }

  public async onConfirm(ok: boolean) {
    if (ok && this.selectedId) {
      await this.rejectApplication({ id: this.selectedId, operate: false });
      this.queryAudits();
      this.selectedId = null;
    } else {
      this.confirmVisible = false;
    }
  }
}
